import { render, staticRenderFns } from "./AllProductsView.vue?vue&type=template&id=c8312f66"
import script from "./AllProductsView.vue?vue&type=script&lang=js"
export * from "./AllProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports